import { DateFormatter } from '@repo/toolkit/date'

import useTranslate from '../../../../lib/hooks/use-translate'
import { ProductTypeEnum } from '../../../../lib/types/enums/product/product-type.enum'
import { JourneyLight } from '../../../../lib/types/models/product/journey'
import { getTranslatedName } from '../../../../lib/utils/functions/translation.functions'
import PeriodBadge from '../../../elements/period-badge'

type Props = {
  journey: JourneyLight
}

const OlCenterEnrollmentTableJourneyInfo = ({ journey }: Props) => {
  const { t, currentLanguage } = useTranslate()

  const reference = journey.reference
  const date = `${DateFormatter.DDMMYYYY(journey.date.departureDate)} ${t('to')} ${DateFormatter.DDMMYYYY(journey.date.returnDate)}`
  const formula = getTranslatedName(journey.date.product.formula, currentLanguage) || '—'
  const option = getTranslatedName(journey.mainOption, currentLanguage) || '—'
  const period = journey.date.period

  const numberOfHoursPerWeek =
    journey.date.product.type === ProductTypeEnum.ONE_TO_ONE
      ? journey.date.product.numberOfHoursPerWeek
      : undefined

  return (
    <PeriodBadge
      className="w-64 h-fit py-2 text-wrap"
      period={period}
      text={`${reference} - ${date} - ${formula} - ${option}${numberOfHoursPerWeek ? ` - ${t('product.number.of.hours.per.week', { hours: numberOfHoursPerWeek })}` : ''}`}
    />
  )
}

export default OlCenterEnrollmentTableJourneyInfo
